// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__6Hg6O","amount":"Amount_amount__2UyQs","tip":"Amount_tip__1iqyI","tipHeader":"Amount_tipHeader__2XPdJ","tipsWrap":"Amount_tipsWrap__tBWzR"};